/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'headerIcons/education': {
    width: 26,
    height: 17,
    viewBox: '0 0 26 17',
    data: '<path pid="0" d="M20.856 8.245v6.104s-1.59 2.126-7.876 2.126c-6.166 0-7.814-2.047-7.874-2.124l-.001-.002V8.245l6.61 2.138c.741.24 1.531.264 2.283.072l.249-.072 6.61-2.138zM.968 6.446l.875.323v4.538h-.001l.53 1.017c.087.167.132.353.132.543v.065c0 .63-.491 1.14-1.098 1.14-.607 0-1.099-.51-1.099-1.14v-.065c0-.19.046-.376.133-.543l.53-1.017H.968v-4.86zM14.231.572l.235.064 10.792 3.4c.774.245.814.636.122.895l-.122.042-10.792 3.401c-.743.234-1.915.256-2.736.064l-.235-.064-10.792-3.4c-.774-.245-.815-.636-.122-.895l.122-.042L11.495.636C12.238.402 13.41.38 14.231.572z" _fill="#000" fill-rule="evenodd"/>'
  }
})
